export default __webpack_public_path__ + "static/media/eco-score-C.0481da62.svg";